@if (column.badges) {
  <div class="cell-badges" [class.cell-badges-vertical]="column.badgesLayout === 'vertical'">
    @for (badge of column.badges(item); track $index; let last = $last) {
      <div class="cell-badge-item">
        @if (badge.caption) {
          <span class="cell-badge-caption">{{ badge.caption }}</span>
        }
        <span class="badge" [ngClass]="badge.cssClass ?? 'text-bg-secondary'">{{ badge.label }}</span>
      </div>
      @if (!last && column.badgesSeparator) {
        <i class="cell-badge-separator" [ngClass]="column.badgesSeparator"></i>
      }
    }
  </div>
} @else {
  {{ column.value?.(item) }}
  @if (column.note?.(item); as note) {
    <div class="cell-note">
      <i class="fa fa-info-circle me-1"></i>{{ note }}
    </div>
  }
}
